export default "__VITE_ASSET__B$sCRF5P__"